const reportCenter = {
    label: 'Report Center',
    title: 'Report Center',
    description:
      'The Report Center automates discovery and analysis across KPIs with visual dashboards. Gain sharper insights and make better decisions.',
    createReport: 'Create Report',
    browseTemplates: 'Browse Templates',
    highlightSearch: 'Automated discovery',
    highlightMetrics: 'KPI analysis',
    highlightVisual: 'Visual insights',
    heroMetricTitle: 'Talent volume',
    heroMetricNote: 'Latest snapshot',
    heroChartLabel: 'Connection rate',
    heroChartSubLabel: 'Current scope',
    scopeLabel: 'Scope',
    scopeAll: 'All candidates',
    workspaceLabel: 'Workspace',
    dashboardTab: 'Home',
    templatesTab: 'Template Library',
    sourcesTab: 'Data Sources',
    themeLabel: 'Theme',
    themeOverview: 'Overview',
    themeQuality: 'Quality',
    themeChannel: 'Channel',
    refresh: 'Refresh data',
    metricsTitle: 'KPI Overview',
    metricsDesc: 'Track the most important KPIs at a glance and surface bottlenecks quickly.',
    metricsAction: 'Export KPIs',
    metricTotalCandidates: 'Total candidates',
    metricTotalNote: 'Talent pool size',
    metricAdded: 'Connections added',
    metricAddedNote: 'Connected successfully',
    metricPending: 'Pending verification',
    metricPendingNote: 'In progress',
    metricOpenToWork: 'Open to Work',
    metricOpenToWorkNote: 'High intent',
    metricChipAll: 'All',
    metricChipConnect: 'Connect',
    metricChipPending: 'Pending',
    metricChipOpen: 'Priority',
    overviewTitle: 'Recruiting Operating Overview',
    overviewDesc: 'See funnel, tag performance, job progress, and risks in one workspace.',
    funnelTitle: 'Hiring Funnel',
    funnelPool: 'Candidates in pool',
    funnelReachable: 'Reachable / Connected',
    funnelPending: 'Pending verification',
    funnelPriority: 'Priority follow-up',
    topTagsTitle: 'Top Tag Performance',
    topTagsNote: 'Ranked by candidate volume',
    topTagsRank: 'Rank #{rank}',
    jobSummaryTitle: 'Job Progress Summary',
    jobSummaryNote: 'Monitor workload and completion by job status',
    alertsTitle: 'Risk Alerts',
    alertsNote: 'Surface hiring risks for fast decisions',
    alertBacklogTitle: 'Backlog needs attention',
    alertBacklogDesc: '{count} candidates have not received outreach yet.',
    alertFailedTitle: 'Job analysis failures detected',
    alertFailedDesc: '{count} jobs are currently in failed status.',
    alertHealthyTitle: 'Hiring health is stable',
    alertHealthyDesc: 'No major risks detected in the current workspace.',
    chartsTitle: 'Visualization Panel',
    chartsDesc: 'HR-focused analytics with ECharts-ready chart modules.',
    templatesTag: 'Templates',
    chartTagsTitle: 'Tag distribution',
    chartTagsDesc: 'Candidate volume by tag',
    chartTagsFooter: 'Total',
    chartJobsTitle: 'Job processing',
    chartJobsDesc: 'Status breakdown for job analysis',
    chartJobsFooter: 'Jobs',
    chartFriendTitle: 'Connection status',
    chartFriendDesc: 'Invitation and verification mix',
    chartFriendFooter: 'Connection rate',
    chartTagDistribution: 'Distribution',
    chartTagPipeline: 'Pipeline',
    chartTagStatus: 'Status',
    detailScope: 'Scope',
    detailUpdated: 'Updated',
    viewTags: 'View tags',
    viewJobs: 'View jobs',
    friendAdded: 'Added',
    friendPending: 'Pending',
    friendNotSent: 'Not sent',
    friendActive: 'Active',
    friendOpenToWork: 'Open to Work',
    jobStatusPending: 'Pending',
    jobStatusAnalyzing: 'Analyzing',
    jobStatusCompleted: 'Completed',
    jobStatusFailed: 'Failed',
    templatesTitle: 'Template Library',
    templatesDesc: 'Start from curated templates and reuse your best recruiting reports.',
    templateSearch: 'Search templates',
    templatePreview: 'Preview',
    templateFavorite: 'Favorite',
    templateFavorited: 'Favorited',
    templateUse: 'Use template',
    templateCategoryAll: 'All templates',
    templateCategoryFunnel: 'Hiring Funnel',
    templateCategoryChannel: 'Channel Efficiency',
    templateCategoryPipeline: 'Job Progress',
    templateCategoryReview: 'Management Review',
    templateFunnelTitle: 'Funnel Analysis',
    templateFunnelDesc: 'Track conversion and drop-off at each stage',
    templateFunnelTag: 'Pipeline',
    templateChannelTitle: 'Channel Efficiency',
    templateChannelDesc: 'Compare quality, cost, and conversion',
    templateChannelTag: 'Channel',
    templateQualityTitle: 'Quality Heatmap',
    templateQualityDesc: 'Visualize fit and capability distribution',
    templateQualityTag: 'Quality',
    templatePipelineTitle: 'Stage Duration',
    templatePipelineDesc: 'Time from outreach to onboarding',
    templatePipelineTag: 'Cycle',
    templateTeamTitle: 'Hiring Manager Sentiment',
    templateTeamDesc: 'Feedback and retention signals',
    templateTeamTag: 'Feedback',
    templateForecastTitle: 'Demand Forecast',
    templateForecastDesc: 'Predict hiring peaks and role demand',
    templateForecastTag: 'Forecast',
    templateForecastValue: 'Q2',
    templateKpiPrimary: 'Key KPI',
    templateKpiSecondary: 'Index',
    templateSceneLabel: 'Use case',
    templateRoleLabel: 'Recommended role',
    templateRoleLeader: 'Recruiting Lead',
    templateRoleOps: 'Recruiting Ops',
    templateRoleRecruiter: 'Recruiter',
    templateRoleManager: 'Team Manager',
    templateRoleBoss: 'Leadership',
    templateFreqDaily: 'Daily review',
    templateFreqWeekly: 'Weekly review',
    templateFreqMonthly: 'Monthly review',
    templateFunnelScene: 'Best for weekly conversion reviews',
    templateChannelScene: 'Best for comparing tag and channel efficiency',
    templateQualityScene: 'Best for spotting high-quality talent pools',
    templatePipelineScene: 'Best for monitoring job progress and delays',
    templateTeamScene: 'Best for team-level performance reviews',
    templateForecastScene: 'Best for leadership trend reporting',
    dataSourceTitle: 'Data Source Overview',
    dataSourceDesc: 'Show where each report metric comes from and how the data is grouped.',
    sourceTalentTitle: 'Talent Sources',
    sourceTalentPool: 'Talent pool size',
    sourceTalentOpen: 'Open to Work',
    sourceTalentActive: 'Active talent',
    sourceTagTitle: 'Tag Sources',
    sourceTagCount: 'Number of tags',
    sourceTagCurrent: 'Current scope',
    sourceTagTop: 'Top tag',
    sourceJobTitle: 'Job Sources',
    sourceJobTotal: 'Total jobs',
    sourceJobCompleted: 'Completed',
    sourceJobFailed: 'Failed',
    sourceDefinitionTitle: 'Metric Definitions',
    definitionTalentTitle: 'Talent data',
    definitionTalentDesc: 'Aggregated from your tag pools and candidate status fields.',
    definitionTagTitle: 'Tag data',
    definitionTagDesc: 'Grouped by tag to show candidate volume and pool distribution.',
    definitionJobTitle: 'Job data',
    definitionJobDesc: 'Grouped by job analysis status to show progress and exceptions.',
    definitionContactTitle: 'Contact data',
    definitionContactDesc: 'Connection metrics are based on outreach and verification states.',
    formName: 'Report name',
    formNamePlaceholder: 'Enter report name',
    formNameRequired: 'Please enter the report name',
    formTemplate: 'Select template',
    exportHint: 'Choose a format to export the report.',
    exportSuccess: '{format} report exported',
    createSuccess: 'Report created',
    fetchFailed: 'Failed to load report data',
    unavailable: 'Coming soon',
  }

export default reportCenter
